// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import qs from "qs";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Vant from "vant";
import "vant/lib/index.css";
import Print from "@/plugs/print";
Vue.use(Print);
Vue.use(Vant);
// import 'lib-flexible/flexible'
Vue.prototype.$qs = qs;
// import Vue from 'vue';
Vue.config.productionTip = false;

import {
  Button,
  Select,
  Menu,
  Submenu,
  MenuItem,
  Input,
  Loading,
  Card,
  Form,
  FormItem,
  Timeline,
  TimelineItem,
  Option,
  Dialog,
  Table,
  TableColumn,
  MessageBox,
  Pagination,
  Upload,
  Steps,
  Step,
  Divider,
  // Notification,
  Cascader,
  Message
} from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
import Distpicker from "v-distpicker";

Vue.component("v-distpicker", Distpicker);

Vue.use(Element)
  .use(Button)
  .use(Select)
  .use(Menu)
  .use(Submenu)
  .use(MenuItem)
  .use(Input)
  .use(Loading)
  .use(Card)
  .use(Form)
  .use(FormItem)
  .use(Timeline)
  .use(TimelineItem)
  .use(Option)
  .use(Dialog)
  .use(Divider)
  .use(Table)
  .use(TableColumn)
  .use(Pagination)
  .use(Upload)
  .use(Cascader)
  .use(Steps)
  .use(Step);

import { NoticeBar, Uploader, Toast, Area } from "vant";
import "vant/lib/index.css";
Vue.use(NoticeBar)
  .use(Uploader)
  .use(Toast)
  .use(Area);

import Axios from "axios";
import QS from "qs";
let axios = Axios.create({
  baseURL: "https://stoexpresscanada.com/index",
  timeout: 10000,
  headers: {
    "content-type": "application/x-www-form-urlencoded"
  }
});

Vue.prototype.$axios = axios;

Vue.prototype.qs = QS;
let isLogin = false;
Vue.prototype.$isLogin = isLogin;
router.beforeEach((to, from, next) => {
  if (window.sessionStorage.uid) {
    store.commit("login", true);
  }
  next();
});
import Router from "vue-router";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js